import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ContentWrapper, BuildRaceCardButtonWrapper } from './NewRacingPage.style';
import { PriceChangeLegend } from 'src/domains/layouts/webview/components/priceChangeLegend/PriceChangeLegend';
import { getHeader, renderButton } from './NewRacingPage.helpers';
import { SportHeaderStar } from 'src/domains/layouts/webview/components/sportHeader/SportHeader';
import { SportRacesTypeParamType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { SeoPagesContent } from 'src/domains/layouts/webview/components/seoPages/SeoPages';
import { NextRacesSportPage } from 'src/domains/sportsbook/webview/components/nextRaces/NextRacesSportPage';
import { NextRacesState } from 'src/domains/sportsbook/webview/components/nextRaces/NextRaces.state';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import { RacingMeetingsContainer } from '../racingMeetingsContainer/RacingMeetingsContainer';

interface PropsType {
    sport: 'horseracing' | 'greyhoundracing';
    filterType: SportRacesTypeParamType | null;
    eventId: EventId | null;
}

export const NewSportRacingContent = observer('NewSportRacingContent', (props: PropsType) => {
    const { sport, eventId } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const starRouter = StarRouter.get(common);
    const { sportsbookVariant } = configState.componentVariants;
    const filterType = props.filterType ?? 'uk-ire';
    const state = AppSportsBookState.get(common).horseRacingState.get(sport);

    const selectedNew = state.selectedNew;
    const buildRaceCard = filterType === 'build-racecard';

    const options = getHeader(sport);
    const isAntePostReverse = filterType === 'ante-post' && configState.isAntePostReverse;

    const [nextRacesState] = React.useState(() => new NextRacesState(common, sport));

    return (
        <section className='sport-racing'>
            <SportHeaderStar
                options={options}
                sportId={sport}
                key={`sport-header + ${sport}`}
                isCompetitionPage={false}
                competitionId={null}
            />

            <ContentWrapper
                isAntePostReverse={isAntePostReverse}
                variant={sportsbookVariant}
            >
                <NextRacesSportPage
                    nextRacesState={nextRacesState}
                    sport={sport}
                />

                <RacingMeetingsContainer
                    sport={sport}
                    filterType={filterType}
                    eventId={eventId}
                    isLoading={nextRacesState.isLoadingEventsCollectionEarly}
                />
            </ContentWrapper>

            <BuildRaceCardButtonWrapper variant={sportsbookVariant}>
                {selectedNew.racesSelected() > 0 && buildRaceCard
                    ? renderButton(starRouter, state.isBuilding, state.selectedNew, sport, sportsbookVariant)
                    : null}
            </BuildRaceCardButtonWrapper>
            <SeoPagesContent pageSlug={sport} />
            <PriceChangeLegend isRace={true} />
        </section>
    );
});
